import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Config from "../../config";
import {FiltersRow, InputRow} from "../../utils/table-utils";
import User from "../../../../services/user";

import * as U from "../../desktop-templates/menu-user";

import AwrabetProfilePage, {
    PasswordChange as AwrabetPasswordChange
} from "../../../awrabet/desktop-components/user/menu-profile";

export default class ProfilePage extends AwrabetProfilePage {
    render() {
        return <div>
			<U.SubTabsContainer>
				{Object.entries(this.state.tabs.list).map(
					([key,item]) => <U.Tab selected={key === this.state.tabs.current} onClick={e => this.switchTabs(key)} >{item.label}</U.Tab>
				)}
			</U.SubTabsContainer>
            <div class="user-menu-header main-text-color p-2 text-base font-bold m-3 capitalize rounded">{this.state.tabs.list[this.state.tabs.current].description}</div>
            {this.state.tabs.current === 'password' && <PasswordChange />}
			{this.state.tabs.current === 'profile' && <ProfileDetails />}
        </div>;
    }
}

function ProfileDetails() {
	return <div class="px-3">
		<FiltersRow>
			<InputRow
				label={window.Translation(msg`Name`)}
				type="text"
				disabled={true}
				value={User.username()}
			/>
			<InputRow
				label={window.Translation(msg`Surname`)}
				type="text"
				disabled={true}
				value={User.username()}
			/>
		</FiltersRow>
	</div>
}

class PasswordChange extends AwrabetPasswordChange {
    render() {
        return <div class="px-3">
            <form id="password-change" method="post" onSubmit={e => {e.preventDefault(); this.savePassword()}}>
                <FiltersRow>
                    <InputRow
                        label={window.Translation(msg`Vecchia Password`)}
                        type="password"
                        onInput={e => {
                            this.state.oldpass = e.target.value;
                            this.setState({});
                        }}
                        value={this.state.oldpass}
                        required={true}
                    />
                </FiltersRow>
                <FiltersRow>
                    <InputRow
                        label={window.Translation(msg`Nuova Password`)}
                        type="password"
                        onInput={e => {
                            this.state.newpass = e.target.value;
                            this.setState({});
                        }}
                        value={this.state.newpass}
                        required={true}
                    />
                    <InputRow
                        label={window.Translation(msg`Conferma Nuova Password`)}
                        type="password"
                        onInput={e => {
                            this.state.confpass = e.target.value;
                            this.setState({});
                        }}
                        value={this.state.confpass}
                        required={true}
                    />
                </FiltersRow>
                <FiltersRow class="pt-5">
                    <input
                        type="submit"
                        class="px-4 py-2 sm:ml-5 bg-amber-400 text-black rounded m-auto"
                        value={window.Translation(msg`Cambia Password`)}
                    />
                </FiltersRow>
            </form>
        </div>;
    }
}